import React, { Component } from 'react';
import QrReader from 'react-qr-reader';

export default class QRReader extends Component {
	constructor(props){
		super(props)
		this.state = {
		  delay: 500,
		  result: 'No result',
		}

		this.handleScan = this.handleScan.bind(this)
	}

	handleScan(result){
		if(result){
		  this.setState({ result })
		}
	}

	handleError(err){
		console.log(err)
	}
	
	render(){
		/*const previewStyle = {
			// height: 240,
			// width: 320,
		}*/
		return(
			<div className="card-block">
				<div className="row">
					<div className="col-sm-12 book-a-tool-title">
					  <h4 className="card-title mb-0">
						<span>QR Reader</span>
					  </h4>
					</div>
				</div>
				<hr/>
				<div className="row">
					<div className="form-group col-md-4">
						<QrReader
							delay={this.state.delay}
							// style={previewStyle}
							onError={this.handleError}
							onScan={this.handleScan}
							// className="qr-reader-box"
						/>
					</div>
					<div className="form-group col-md-12">
						<span>{this.state.result}</span>
					</div>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/App/qrreader/helper/component/QRReader.js